// Copyright 2023, mochabug AB
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true,ts_nocheck=true"
// @generated from file mochabugapis/adapt/graph/v1/vertex_metadata.proto (package mochabugapis.adapt.graph.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../../buf/validate/validate_pb";
import type { Exchange, ExchangeJson } from "./exchange_pb";
import { file_mochabugapis_adapt_graph_v1_exchange } from "./exchange_pb";
import type { Receiver, ReceiverJson } from "./receiver_pb";
import { file_mochabugapis_adapt_graph_v1_receiver } from "./receiver_pb";
import type { Transmitter, TransmitterJson } from "./transmitter_pb";
import { file_mochabugapis_adapt_graph_v1_transmitter } from "./transmitter_pb";
import type { UserDefinedExchangeOptions, UserDefinedExchangeOptionsJson } from "./user_defined_exchange_options_pb";
import { file_mochabugapis_adapt_graph_v1_user_defined_exchange_options } from "./user_defined_exchange_options_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mochabugapis/adapt/graph/v1/vertex_metadata.proto.
 */
export const file_mochabugapis_adapt_graph_v1_vertex_metadata: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_mochabugapis_adapt_graph_v1_exchange, file_mochabugapis_adapt_graph_v1_receiver, file_mochabugapis_adapt_graph_v1_transmitter, file_mochabugapis_adapt_graph_v1_user_defined_exchange_options]);

/**
 * VertexMetadata represents the configuration for a vertex, detailing its inputs,
 * outputs, and processes (such as procedures and streams).
 *
 * @generated from message mochabugapis.adapt.graph.v1.VertexMetadata
 */
export type VertexMetadata = Message<"mochabugapis.adapt.graph.v1.VertexMetadata"> & {
  /**
   * Indicates if the vertex configuration is complete. Defaults to 'false'.
   *
   * @generated from field: bool complete = 1;
   */
  complete: boolean;

  /**
   * Input points for the vertex. Must contain between 1 and 50 receivers,
   * each with a unique name.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.v1.Receiver receivers = 2;
   */
  receivers: Receiver[];

  /**
   * Output points for the vertex. Can contain up to 50 transmitters,
   * each with a unique name.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.v1.Transmitter transmitters = 3;
   */
  transmitters: Transmitter[];

  /**
   * Processes initiated by transmitters and responded to by receivers.
   * Limited to 100 unique exchanges.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.v1.Exchange exchanges = 4;
   */
  exchanges: Exchange[];

  /**
   * Options for user-defined exchanges on this vertex.
   * When set, users can create their own exchanges at graph construction time.
   *
   * @generated from field: optional mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions ude_options = 5;
   */
  udeOptions?: UserDefinedExchangeOptions | undefined;

  /**
   * A unix cron expression to determine when the task should run.
   *
   * @generated from field: optional string cron_schedule = 6;
   */
  cronSchedule?: string | undefined;
};

/**
 * VertexMetadata represents the configuration for a vertex, detailing its inputs,
 * outputs, and processes (such as procedures and streams).
 *
 * @generated from message mochabugapis.adapt.graph.v1.VertexMetadata
 */
export type VertexMetadataJson = {
  /**
   * Indicates if the vertex configuration is complete. Defaults to 'false'.
   *
   * @generated from field: bool complete = 1;
   */
  complete?: boolean;

  /**
   * Input points for the vertex. Must contain between 1 and 50 receivers,
   * each with a unique name.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.v1.Receiver receivers = 2;
   */
  receivers?: ReceiverJson[];

  /**
   * Output points for the vertex. Can contain up to 50 transmitters,
   * each with a unique name.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.v1.Transmitter transmitters = 3;
   */
  transmitters?: TransmitterJson[];

  /**
   * Processes initiated by transmitters and responded to by receivers.
   * Limited to 100 unique exchanges.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.v1.Exchange exchanges = 4;
   */
  exchanges?: ExchangeJson[];

  /**
   * Options for user-defined exchanges on this vertex.
   * When set, users can create their own exchanges at graph construction time.
   *
   * @generated from field: optional mochabugapis.adapt.graph.v1.UserDefinedExchangeOptions ude_options = 5;
   */
  udeOptions?: UserDefinedExchangeOptionsJson;

  /**
   * A unix cron expression to determine when the task should run.
   *
   * @generated from field: optional string cron_schedule = 6;
   */
  cronSchedule?: string;
};

/**
 * Describes the message mochabugapis.adapt.graph.v1.VertexMetadata.
 * Use `create(VertexMetadataSchema)` to create a new message.
 */
export const VertexMetadataSchema: GenMessage<VertexMetadata, {jsonType: VertexMetadataJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_graph_v1_vertex_metadata, 0);

